import { defineStore } from 'pinia'
import { getEnv, setTitleByRoute, replaceDomain, isMeetingDomain } from '@/utils'
import SSOClient, { DomainManager } from '@kuailu/sso'
import { useCacheStore } from './cache.ts'
import { setupI18n } from '@/i18n'
import { computed } from 'vue'
import { router } from '@/router/index.ts'

export const useSSOStore = defineStore('sso', () => {
  const token = computed(() => SSOClient.accessToken)

  const localeOptions = computed(() => SSOClient.baseLocaleOptions ?? [])
  const currentLocale = ref(SSOClient.currentLocale)

  async function changeLocale(_: string) {
    await SSOClient.changeLocale(_ as any)
    await setupI18n()
    currentLocale.value = SSOClient.currentLocale
    setTitleByRoute(router.currentRoute.value)
  }
  function logout() {
    SSOClient.launchLogout()
  }
  async function init() {
    SSOClient.init({
      clientId: useCacheStore().clientId,
      env: getEnv(),
      projectId: 'saas-auth',
      region: import.meta.env?.VITE_DEPLOY_REGION || 'cn'
    })
    SSOClient.stateManager.showLoading()
    currentLocale.value = SSOClient.currentLocale
    //启动定时刷新token
    SSOClient.startRefreshTimer()
  }

  function openPdf(type) {
    // const baseUrl = replaceDomain(location.origin)
    let targetDomain = DomainManager.getTargetDomain('portal')
    // 替换域名中的 quickegret.com 或 kuailutech.cn 为 kuailumeeting.com
    if (isMeetingDomain()) {
      targetDomain = targetDomain.replace(/quickegret\.com|kuailutech\.cn/g, 'kuailumeeting.com')
    }

    if (type === 1) {
      return `https://${targetDomain}/privacy-agreement/open-user-agreement?lang=${currentLocale.value}`
    } else if (type === 0) {
      return `https://${targetDomain}/privacy-agreement/open-privacy-policy?lang=${currentLocale.value}`
    }
  }

  return {
    localeOptions,
    currentLocale,
    changeLocale,
    logout,
    token,
    openPdf,
    init
  }
})
